<template>
  <div id="app">
    <TopNav />
    <router-view :contentType="contentType"/> <!-- 路由视图 -->
    <div v-if="!$root.isMob" class="pcMenuContect" @click="linkTo('https://work.weixin.qq.com/kfid/kfc566d985476107923')">
        <i class="icon el-icon-service"></i>
        联系人工客服
    </div> 
    <FooterPage/>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue';
import FooterPage from '@/components/view/FooterPage.vue';
import axios from 'axios';

export default {
  name: 'App',
  components: {
    TopNav,
    FooterPage
  },
  watch: {
    '$route.path': function(){
      this.loadingOpen();
      this.isMobile();
    }
  },
  methods: {
    linkTo(url){
        this.mobMenuVisible = false;
        if(url[0] == '/'){
            url = '/#'+url;
        }
        window.open(url,'_blank');
      },
    async getCategoryData(id=0){
      try {
          const [categorylist] = await Promise.all([
              axios.get(this.baseUrl+'index.php/api/products/categorylist?pid='+id), //产品分类              
          ]);
          if(categorylist.data.code == 1){
              let categoryListData = categorylist.data.data;
              return categoryListData;
          }
          return [];
      } catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }        
        return [];
      }
    },
    async getquestionData(id = 1){
      try {
          const [baseData] = await Promise.all([
              axios.get(this.baseUrl+'/api/questions/questioninfo' + '?id=' + id), //基础信息
          ]);
          // console.log(baseData);
          if(baseData.data.code == 1){
              let questiondata = baseData.data.data;
              return questiondata;
          }
          return [];
      }catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }        
        return [];
      }
    },
    async getProductListData(category_id=0,brand=0,page = 1,limit=8){
      try {
          const [productList] = await Promise.all([
            axios.get(this.baseUrl+'index.php/api/products/productlist?category_id='+category_id+'&brand_id='+brand+'&yn_recommend=&keyword=&list_rows='+limit+'&page='+page), //产品列表
          ]);
          if(productList.data.code == 1){
            let data = productList.data.data.data;
            let dataFull = productList.data;
            return [data,dataFull];
          }
          return [];
      }
      catch (error) {        
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getProductDetailData(id=0){
      try {
            const [productList] = await Promise.all([
              axios.get(this.baseUrl+'/index.php/api/products/show?id='+id), //产品详情
            ]);
            if(productList.data.code == 1){
              let data = productList.data.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getBrandData(id=0){
      try {
            const [brandList] = await Promise.all([
              axios.get(this.baseUrl+'/index.php/api/products/brandlist?category_id='+id), //品牌列表
            ]);
            if(brandList.data.code == 1){
              let data = brandList.data.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getSimilarProductList(id=0){
      try {
            const [productList] = await Promise.all([
              axios.get(this.baseUrl+'/index.php/api/products/similarproductlist?product_id='+id+'&list_rows=4'), //品牌列表
            ]);
            if(productList.data.code == 1){
              let data = productList.data.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getProjectCate(){
      try {
            const [cate] = await Promise.all([
              axios.get(this.baseUrl+'/index.php/api/projectapply/catlist'), //项目分类
            ]);
            if(cate.data.code == 1){
              let data = cate.data.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getProjectList(category_id,page=1){
      try {
            const [list] = await Promise.all([
              axios.get(this.baseUrl+'/index.php/api/projectapply/projectlist?category_id='+category_id+'&list_rows=3&page='+page), //项目列表
            ]);
            if(list.data.code == 1){
              let data = list.data.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getProjectDetail(id){
      try {
            const [detail] = await Promise.all([
              axios.get(this.baseUrl+'/index.php/api/projectapply/show?id='+id), //项目详情
            ]);
            if(detail.data.code == 1){
              let data = detail.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getBanner(id){
      let showType = 1;
      if(this.$root.isMob){
        showType = 2
      }
      try {
            const [banner] = await Promise.all([
              axios.get(this.baseUrl+'index.php/api/base/banners?page='+id+'&show_type='+showType), //轮播图
            ]);
            if(banner.data.code == 1){
              let data = banner.data;
              let fixedData = {data:[]};
              data.data.forEach(item => {
                if(item.status == "normal"){
                  fixedData.data.push(item);
                }
              });
              return fixedData;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getCompanyInfo(){
      try {
            const [info] = await Promise.all([
              axios.get(this.baseUrl+'index.php/api/aboutus/companylist'), //公司介绍
            ]);
            if(info.data.code == 1){
              let data = info.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getCompanyHoner(){
      try {
            const [info] = await Promise.all([
              axios.get(this.baseUrl+'index.php/api/aboutus/honerlist'), //公司介绍
            ]);
            if(info.data.code == 1){
              let data = info.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getJoinUs(){
      try {
            const [info] = await Promise.all([
              axios.get(this.baseUrl+'index.php/api/aboutus/joinuslist'), //加入我们
            ]);
            if(info.data.code == 1){
              let data = info.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getLinks(type){
      try {
            const [info] = await Promise.all([
              axios.get(this.baseUrl+'index.php/api/base/links?type='+type), //友情连接2及合作伙伴1
            ]);
            if(info.data.code == 1){
              let data = info.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getNewsList(cate="",limit="",page=""){
      try {
            const [info] = await Promise.all([
              axios.get(this.baseUrl+'index.php/api/news/newlist?category_id='+cate+'&recommend=&keyword=&list_rows='+limit+'&page='+page), //新闻列表
            ]);
            if(info.data.code == 1){
              let data = info.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getNewsDetail(id=""){
      try {
            const [info] = await Promise.all([
              axios.get(this.baseUrl+'index.php/api/news/show?id='+id), //新闻详情
            ]);
            if(info.data.code == 1){
              let data = info.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getNanoItemList(id="",limit="",page=""){
      try {
            const [info] = await Promise.all([
              axios.get(this.baseUrl+'index.php/api/lab/lists?category_id='+id+'&recommend=&list_rows='+limit+'&page='+page), //虚拟实验室-项目列表
            ]);
            if(info.data.code == 1){
              let data = info.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    async getNanoCate(){
      try {
            const [info] = await Promise.all([
              axios.get(this.baseUrl+'index.php/api/lab/categorylist'), //虚拟实验室-大类
            ]);
            if(info.data.code == 1){
              let data = info.data;
              return data;
            }
            return [];
        }
      catch (error) {
        
        if(this.$route.path != '/error'){
          this.$router.replace('error');
        }  
        return [];
      }
    },
    changeContentType(type,event=null,targetId=null){
      let mobNav = document.getElementsByClassName('mobNav')[0];
      let navs = mobNav.getElementsByClassName('nav');
      for(let i = 0; i < navs.length; i++){
        navs[i].classList.remove('active');
      }
      if(event != null){
        event.target.classList.add('active');
      }      
      if(targetId != null){
        document.getElementById(targetId).classList.add('active');
      }
      this.contentType = type;
      window.scrollTo(0,0);
    },
    loadingOpen(){
        this.loading = this.$loading({
        lock: true,
        spinner:"el-icon-setting",
        text: '拼命加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
        });
    },
    loadingClose(){
      this.loading.close();
      if(this.$route.query.goto == undefined){
        window.scrollTo(0,0);
      }      
    },
    isMobile(){
      //判断用户的设备是否是手机
      let isMob = (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))?true:false;
      if(isMob){
        this.$root.isMob = true;
      }      
      else{
        this.$root.isMob = false;
      }
    },
    mapHandler() {
      let zoom = 14;
      if(this.$root.isMob){
        zoom = 13;
      }
      let data={
        center: {lng: window.config.mapLng, lat: window.config.mapLat},
        zoom: zoom
      };
      return data
    },
  },
  data() {
    return {
      links: [],
      baseUrl:window.config.apiUrl,
      categoryList:[],
      loading:false,
      contentType:1,
    }
  },
  created() {
    this.isMobile();
    //接口数据S
    this.$root.getCategoryData = this.getCategoryData;
    this.$root.getProductListData = this.getProductListData;
    this.$root.getProductDetailData = this.getProductDetailData;
    this.$root.getBrandData = this.getBrandData;
    this.$root.getSimilarProductList = this.getSimilarProductList;
    this.$root.getProjectCate = this.getProjectCate;
    this.$root.getProjectList = this.getProjectList;
    this.$root.getProjectDetail = this.getProjectDetail;
    this.$root.getBanner = this.getBanner;
    this.$root.getCompanyInfo = this.getCompanyInfo;
    this.$root.getCompanyHoner = this.getCompanyHoner;
    this.$root.getJoinUs = this.getJoinUs;
    this.$root.getLinks = this.getLinks;
    this.$root.getNewsList = this.getNewsList;
    this.$root.getNewsDetail = this.getNewsDetail;
    this.$root.getNanoCate = this.getNanoCate;
    this.$root.getNanoItemList = this.getNanoItemList;
    this.$root.getquestionData = this.getquestionData;
    //接口数据E

    //功能S
    this.$root.loadingClose = this.loadingClose;
    this.$root.loadingOpen = this.loadingOpen;
    this.$root.mapHandler = this.mapHandler;
    this.$root.changeContentType = this.changeContentType;
    //功能E
  },
  mounted() {
    this.loadingOpen();
  }
}
</script>
<style lang="scss" src="@/assets/css/app.scss"></style>
